import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const challengePaymentSearchSchema = z.object({
  backUrl: z.string().optional(),
  source: z.string().optional(),
});

export const Route = createFileRoute("/$lang/challenge-payment/$challengeId")({
  component: React.lazy(() =>
    import("@/pages/challenge-payment").then((mod) => ({
      default: mod.ChallengePaymentFlow,
    })),
  ),
  validateSearch: (search) => challengePaymentSearchSchema.parse(search),
});
